<template>
  <span>
    <a v-if="!is_ticket_exist" @click="create_ticket" :class="{ 'is-loading': is_loading }" class="button button-ticket is-fullwidth">
      <!-- <img class="icon" src="@/assets/tickets.svg" /> -->
      <span v-if="lang_data">{{ localization("app-create-ticket", "Create ticket") }}</span>
    </a>

    <a v-else @click="view_ticket" :class="{ 'is-loading': is_loading }" class="button button-ticket is-fullwidth">
      <img class="icon" src="@/assets/tickets.svg" />
      <span v-if="lang_data">{{ localization("app-view-ticket", "View ticket") }}</span>
    </a>
  </span>
</template>
<script>
  import APIService from "@/api.service";
  import { mapState } from "vuex";
  import _ from "lodash";

  export default {
    props: ["feature"],
    data() {
      return {
        is_loading: false,
        is_ticket_exist: false,
      };
    },
    created() {
      if (this.feature.properties.element && _.isObject(this.feature.properties.element)) {
        this.is_ticket_exist = this.feature.properties.element.properties.main_ticket ? true : false;
      }
    },
    computed: {
      ...mapState(["orthos", "vectors", "draw", "current_organization"]),
    },
    watch: {
      feature() {
        if (this.feature.properties.element && _.isObject(this.feature.properties.element)) {
          this.is_ticket_exist = this.feature.properties.element.properties.main_ticket ? true : false;
        } else {
          this.is_ticket_exist = false;
        }
      },
    },
    methods: {
      get_organization_name(feature) {
        let group = _.find(this.orthos, (f) => f[0].groupUid === feature.properties.groupUid);
        if (group && group[0].organization) return group[0].organization.uid;
        return "";
      },
      async create_ticket() {
        try {
          this.is_loading = true;
          let apiService = new APIService();
          let action = async (element) => {
            let centroid = turf.centroid(this.feature);

            let description = `<p>&nbsp;</p><figure class="table"><table><tbody><tr><td><strong>Temperature Difference</strong></td><td>&nbsp;temperature_difference <span style="color:rgb(255,255,255);"><strong>℃</strong></span></td></tr><tr><td><strong>Issue Timestamp</strong></td><td>&nbsp;issue_timestamp</td></tr><tr><td><strong>Project</strong></td><td>&nbsp;project_name</td></tr><tr><td><strong>Group</strong></td><td>&nbsp;group_name</td></tr></tbody></table></figure><p>&nbsp;</p>`;

            description = description.replace("string_number", this.feature.properties.string_number || "");
            description = description.replace(
              "temperature_difference",
              this.feature.properties.temperature_difference ? this.feature.properties.temperature_difference.toFixed(2) : 0
            );
            description = description.replace("issue_timestamp", this.feature.properties.timestamp || "");
            // Add project_details
            if (this.feature.properties.project_details) {
              description = description.replace("project_name", this.feature.properties.project_details.projectName || "");
              description = description.replace("group_name", this.feature.properties.project_details.groupName || "");
            }

            let body = {
              targetElement: element,
              organization: this.get_organization_name(this.feature),
              name: `${this.feature.properties.string_number || this.feature.properties.uid} (${
                this.vectors[this.feature.properties.class_id].description
              })`,
              location: centroid ? centroid.geometry : {},
              properties: {
                projectUid: this.feature.properties.project_details.projectUid,
              },
              description: description,
            };
            let ticket = await apiService
              .create_ticket({ body })
              .then((res) => res.data)
              .catch((err) => {
                this.is_loading = false;
                this.is_ticket_exist = false;
              });
            let main_ticket = (
              await apiService.update_issue_props({
                issue_id: this.feature.properties.uid,
                body: {
                  ticketUid: ticket.uid,
                },
              })
            ).data;
            this.draw.setFeatureProperty(this.feature.id, "element", main_ticket.element);
            this.is_loading = false;
            this.is_ticket_exist = true;
          };

          if (this.feature.properties.element && _.isObject(this.feature.properties.element)) {
            action(this.feature.properties.element);
          } else if (_.isString(this.feature.properties.element)) {
            let cookies_organization;
            if (this.current_organization && this.current_organization.uid) {
              cookies_organization = this.current_organization;
            } else {
              cookies_organization = state.window.$cookies.get("user_organization");
              if (!cookies_organization) return;

              cookies_organization = JSON.parse(atob(cookies_organization));
            }
            let query = "?organization=" + cookies_organization.uid;
            let results = (
              await apiService.get_element({
                url: this.feature.properties.element + query,
              })
            ).data;
            action(results.element);
          }
        } catch (err) {
          this.is_loading = false;
          this.is_ticket_exist = false;
        }
      },
      view_ticket(tab) {
        let feature = this.draw.get(this.feature.id);
        if (!feature.properties.element || !feature.properties.element.properties || !feature.properties.element.properties.main_ticket) {
          this.is_ticket_exist = false;
          return;
        }
        parent.postMessage(
          {
            name: "show_ticket_details",
            ticket: { uid: feature.properties.element.properties.main_ticket },
          },
          "*"
        );

        // window.open(
        //   `${process.env.VUE_APP_EBS_FRONTEND}/tickets/${feature.properties.element.properties.main_ticket}/details`,
        //   "_blank"
        // );
      },
    },
  };
</script>

<style lang="scss">
  .button-ticket {
    border-radius: 6px;
    box-shadow: 0 2px 5px 0 rgba(92, 126, 247, 0.2);
    background-color: #5c7ef7;
    color: white;
    font-family: Barlow-semibold;
    font-size: 14px !important;
    height: 40px;
  }
</style>
